import * as PIXI from 'pixi.js'

export default class BackgroundPlane extends PIXI.NineSlicePlane {
  /**
   * @param {number} width - width of the plane
   * @param {number} height - height of the plane
   * @param {number} leftWidth - size of the left vertical bar (A)
   * @param {number} topHeight - size of the top horizontal bar (C)
   * @param {number} rightWidth - size of the right vertical bar (B)
   * @param {number} bottomHeight - size of the bottom horizontal bar (D)
   */
  resize(width, height, leftWidth, topHeight, rightWidth, bottomHeight) {
    this._width = width
    this._height = height
    this._leftWidth = leftWidth
    this._topHeight = topHeight
    this._rightWidth = rightWidth
    this._bottomHeight = bottomHeight
    this._refresh()
  }

  destroy() {
    this.texture.destroy(false)
    super.destroy()
  }
}
